export const REQUEST_CHARGES = 'REQUEST_CHARGES';
export const RECEIVE_CHARGES = 'RECEIVE_CHARGES';
export const ERROR_CHARGES = 'ERROR_CHARGES';
